import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { API_BASE_URL_SERVICE } from '../../../../../projects/kiene-core/src/lib/kiene-core.config';
import { KieneTableService } from '../../../components/kiene-table/kiene-table.service';
import { Tierart } from '../tierart';
import { MessageService } from '../../../../../projects/kiene-core/src/lib/services/message-service/message.service';

@Component({
    selector: 'kiene-tierart-dialog',
    templateUrl: './tierart-dialog.component.html',
    styleUrls: ['./tierart-dialog.component.scss'],
})
export class TierartDialogComponent implements OnInit {
    tierart: Tierart;
    mnp_rind_ctrl = new UntypedFormControl();
    gt_eight_ctrl = new UntypedFormControl();
    mnp_schwein_ctrl = new UntypedFormControl();
    gt_thirty_ctrl = new UntypedFormControl();
    hit_ctrl = new UntypedFormControl();
    qs_ctrl = new UntypedFormControl();

    constructor(
        public dialogRef: MatDialogRef<TierartDialogComponent>,
        private api: KieneTableService,
        @Inject(API_BASE_URL_SERVICE) private apiBaseUrl: string,
        private messageService: MessageService,
        @Inject(MAT_DIALOG_DATA) public data: any,
    ) {
        if (data.tierart) {
            this.tierart = data.tierart;
        } else {
            this.tierart = new Tierart();
        }
    }

    ngOnInit() {
        this.mnp_rind_ctrl.setValue(Number(this.tierart.mnp_rind) > 0);
        this.gt_eight_ctrl.setValue(Number(this.tierart.ueber_8_monate) > 0);
        this.mnp_schwein_ctrl.setValue(Number(this.tierart.mnp_schwein) > 0);
        this.gt_thirty_ctrl.setValue(Number(this.tierart.ueber_30_kg) > 0);
        this.hit_ctrl.setValue(Number(this.tierart.hit) > 0);
        this.qs_ctrl.setValue(Number(this.tierart.qs) > 0);
    }

    cancel() {
        this.dialogRef.close(null);
    }

    save() {
        this.tierart.mnp_rind = this.mnp_rind_ctrl.value === true ? 1 : 0;
        this.tierart.ueber_8_monate = this.gt_eight_ctrl.value === true ? 1 : 0;
        this.tierart.mnp_schwein = this.mnp_schwein_ctrl.value === true ? 1 : 0;
        this.tierart.ueber_30_kg = this.gt_thirty_ctrl.value === true ? 1 : 0;
        this.tierart.hit = this.hit_ctrl.value === true ? 1 : 0;
        this.tierart.qs = this.qs_ctrl.value === true ? 1 : 0;

        this.api.updateEntity(this.apiBaseUrl + 'tierart/update.php', this.tierart).subscribe(
            saved => {
                this.messageService.infoMessage('Die Tierart ' + saved.bezeichnung + ' wurde erfolgreich gespeichert!');
                this.dialogRef.close(saved);
            },
            error => {
                this.messageService.errorMessage(
                    'Fehler! Die Tierart ' + this.tierart.bezeichnung + ' konnte nicht gespeichert werden! ',
                    error,
                );
            },
        );
    }
}
